import React, { useState } from 'react';
import { Bot, Sparkles, X } from 'lucide-react';
import AIAssistantSlider from './AIAssistantSlider';

const AIAssistantButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(true)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          fixed bottom-6 right-6 z-30
          w-14 h-14 rounded-full
          bg-gradient-to-br from-purple-600 to-violet-600
          hover:from-purple-500 hover:to-violet-500
          shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50
          flex items-center justify-center
          transition-all duration-300
          ${isHovered ? 'scale-110' : 'scale-100'}
          ${isOpen ? 'opacity-0 pointer-events-none' : 'opacity-100'}
        `}
        title="Assistant IA"
      >
        <Bot className="w-7 h-7 text-white" />

        {/* Sparkle effect */}
        {isHovered && (
          <Sparkles className="absolute -top-1 -right-1 w-4 h-4 text-yellow-400 animate-pulse" />
        )}
      </button>

      {/* Tooltip */}
      {isHovered && !isOpen && (
        <div className="fixed bottom-6 right-24 z-30 bg-purple-900 text-white px-3 py-2 rounded-lg shadow-lg text-sm whitespace-nowrap animate-fade-in">
          <span className="flex items-center gap-2">
            <Bot className="w-4 h-4" />
            Assistant IA - Cliquez pour ouvrir
          </span>
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
            <div className="border-8 border-transparent border-l-purple-900" />
          </div>
        </div>
      )}

      {/* Slider - Only mount when open to prevent unnecessary renders and API calls */}
      {isOpen && <AIAssistantSlider isOpen={isOpen} onClose={() => setIsOpen(false)} />}
    </>
  );
};

export default AIAssistantButton;
